
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { StaffTable } from "@/components/staff/staff-table"
import { AddStaffDialog } from "@/components/staff/add-staff-dialog"
import { PlusIcon, SearchIcon } from "lucide-react"

export default function StaffPage() {
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState("")
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">{t("staff.staffManagement")}</h1>
        <Button onClick={() => setAddDialogOpen(true)}>
          <PlusIcon className="mr-2 h-4 w-4" />
          {t("staff.addStaff")}
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t("staff.title")}</CardTitle>
          <CardDescription>{t("staff.addStaffDescription")}</CardDescription>
          <div className="flex items-center space-x-2 mt-4">
            <div className="relative flex-1">
              <SearchIcon className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                type="search"
                placeholder={t("staff.searchStaff")}
                className="pl-8"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <StaffTable searchQuery={searchQuery} onRefresh={handleRefresh} />
        </CardContent>
      </Card>

      <AddStaffDialog open={addDialogOpen} onOpenChange={setAddDialogOpen} onSuccess={handleRefresh} />
    </div>
  )
}
